'use client';

import { Trans } from '@lingui/macro';
import { Button, Stack } from '@mui/material';
import { useModal } from '@prismo-io/design-system';
import { type FC, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

export const SubmitBtn: FC = () => {
  const { onClose } = useModal();

  const {
    formState: { isValid, isSubmitting, isSubmitSuccessful },
  } = useFormContext();

  useEffect(() => {
    if (isSubmitSuccessful) {
      onClose();
    }
  }, [isSubmitSuccessful]);

  return (
    <Stack alignItems="center">
      <Button
        variant="contained"
        type="submit"
        disabled={!isValid || isSubmitting || isSubmitSuccessful}
      >
        <Trans>Valider</Trans>
      </Button>
    </Stack>
  );
};
